import { render, staticRenderFns } from "./ConfirmEmailDomain.vue?vue&type=template&id=69b35d04&scoped=true&"
import script from "./ConfirmEmailDomain.vue?vue&type=script&lang=js&"
export * from "./ConfirmEmailDomain.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmEmailDomain.vue?vue&type=style&index=0&id=69b35d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b35d04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VFlex,VForm,VMain,VRow,VTextField})
